<template>
  <v-app >
    <v-main>
      <router-view :dataLoaded="dataLoaded" />
    </v-main>
  </v-app>
</template>

<script>
  import { mapActions } from "vuex";
  import routerNames from './router/router-names';

  export default {
    name: 'App',
    data: () => ({
      dataLoaded: false,
    }),
    async created () {
      
      if (this.$router.currentRoute.name === routerNames.Home) {
        // Clear saved state on initial step        
        this.resetState();
      }
      
      // Load Global Configuration at open-module creation
      const resp = await this.loadLoanEnquiryConfig();
      this.dataLoaded = (resp != false);

      // Set CU Skin at startUp
      if (resp == false) console.log("Error reading Global Configuration !!");
      else {
        if (resp.LoanEnquiryConfig.Theme) {
          Object.keys(resp.LoanEnquiryConfig.Theme).forEach(i => {
            this.$vuetify.theme.themes.light[i] = resp.LoanEnquiryConfig.Theme[i];
          });
        }
        else console.log("Theme not found in configuration!!");
      }
    },
    methods: {
      ...mapActions(["loadLoanEnquiryConfig", "resetState"]),
    },
  }
</script>

<style lang="scss">

  @import '@/shared/design/common.scss';
  @import 'design/styles.scss';

</style>
